<template>
  <lf-content-loader :is-loading="runScorecardIds.includes(model.id)">
    <span
      v-if="!modelIsScorecardGroup(model) && hasKnockout(model)"
      v-tooltip="getKnockoutReasons(model)"
    >
      <icon-base
        :icon="IconKnockout"
        :color="
          isKnockoutTriggered(model) ? UTIL_COLORS.WARNING : UTIL_COLORS.DEFAULT
        "
      />
    </span>
    <icon-base
      v-if="
        modelIsScorecardGroup(model) && isGroupKnockoutTriggered(model) !== null
      "
      :icon="IconKnockout"
      :color="
        isGroupKnockoutTriggered(model)
          ? UTIL_COLORS.WARNING
          : UTIL_COLORS.DEFAULT
      "
    />
  </lf-content-loader>
</template>

<script setup lang="ts">
import { UTIL_COLORS } from "@/helpers/constants";
import {
  hasKnockout,
  isGroupKnockoutTriggered,
  isKnockoutTriggered,
  modelIsScorecardGroup,
} from "@/helpers/scorecards";
import { useScorecardsBase, useScorecardsServices } from "@/hooks/scorecards";

import IconKnockout from "@/components/icons/IconKnockout.vue";
import LfContentLoader from "@/components/ui/LfContentLoader.vue";

import type { IScorecard, IScorecardGroup } from "@/models/scorecards";

const { runScorecardIds } = useScorecardsBase();
const { getKnockoutReasons } = useScorecardsServices();

defineProps<{
  model: IScorecard | IScorecardGroup;
}>();
</script>
